<template>
    <v-layout row wrap class="stores-list">
        <v-flex xs12>
            <StoresListComp
                    :displayImage=true
                    :displayGoToDetail=true
                    :select=false
                    :referenceLocation="locationCoords"></StoresListComp>
        </v-flex>
    </v-layout>
</template>


<script>
    import StoresListComp from '@/components/StoresListComp.vue';
    import {getLocation} from '@/_helpers'

    export default {
        name: 'StoresList',
        components: {StoresListComp},
        data() {
            return {
                baseUrl: null,
                location: null,
                locationCoords: null
            }
        },
        mounted() {
            //https://developer.mozilla.org/pt-BR/docs/Web/API/Position
            //Getting user's current geo location
            if (navigator.geolocation) {
                this.locationCoords = getLocation(navigator.geolocation);
            }
        }
    }
</script>

<style scoped>

</style>